import { render, staticRenderFns } from "./ClientesForm.vue?vue&type=template&id=66a7ec9b&scoped=true&"
import script from "./ClientesForm.vue?vue&type=script&lang=js&"
export * from "./ClientesForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientesForm.vue?vue&type=style&index=0&id=66a7ec9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a7ec9b",
  null
  
)

export default component.exports